import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ProspectScreeningService from "services/Setup/Organization/ProspectScreeningServices/prospectScreeningService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  result: {},
  token: localStorage.getItem(AUTH_TOKEN) || null,
  ProspectScreeningList: {},
  loadingProspectScrnLst: false,
  CalculateContract: {},
  loadingCalculateContract: false,
  CalculateAge: {},
  loadingCalculateAge: false,
  ProspectPreScreeningList: {},
  resultProcessProspectScreening: {},
  IsProspectScreeningProceed: false,
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const getProspectScreeningList = createAsyncThunk(
  "ProspectScreening/getProspectScreeningList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProspectScreeningService.getProspectScreeningList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");

        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getProspectPreScreeningList = createAsyncThunk(
  "ProspectScreening/getProspectPreScreeningList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ProspectScreeningService.getProspectPreScreeningList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCalculateContract = createAsyncThunk(
  "ProspectScreening/getCalculateContract",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProspectScreeningService.getCalculateContract(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCalculateAge = createAsyncThunk(
  "ProspectScreening/getCalculateAge",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ProspectScreeningService.getCalculateAge(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const processProspectScreening = createAsyncThunk(
  "ProspectScreening/processProspectScreening",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ProspectScreeningService.processProspectScreening(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const ProspectScreeningSlice = createSlice({
  name: "ProspectScreening",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetProspectScreeningStates: () => initialState,
  },

  extraReducers: (builder) => {
    builder

      //List
      .addCase(getProspectScreeningList.pending, (state) => {
        state.loadingProspectScrnLst = true;
        state.redirect = "";
      })
      .addCase(getProspectScreeningList.fulfilled, (state, action) => {
        state.loadingProspectScrnLst = false;
        state.ProspectScreeningList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getProspectScreeningList.rejected, (state, action) => {
        state.loadingProspectScrnLst = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //preScreening List
      .addCase(getProspectPreScreeningList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getProspectPreScreeningList.fulfilled, (state, action) => {
        state.loading = false;
        state.ProspectPreScreeningList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getProspectPreScreeningList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CalculateContract
      .addCase(getCalculateContract.pending, (state) => {
        state.loadingCalculateContract = true;
        state.redirect = "";
      })
      .addCase(getCalculateContract.fulfilled, (state, action) => {
        state.loadingCalculateContract = false;
        state.CalculateContract = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCalculateContract.rejected, (state, action) => {
        state.loadingCalculateContract = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //CalculateAge
      .addCase(getCalculateAge.pending, (state) => {
        state.loadingCalculateAge = true;
        state.redirect = "";
      })
      .addCase(getCalculateAge.fulfilled, (state, action) => {
        state.loadingCalculateAge = false;
        state.CalculateAge = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCalculateAge.rejected, (state, action) => {
        state.loadingCalculateAge = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //process
      .addCase(processProspectScreening.pending, (state) => {
        state.loading = true;
        state.IsProspectScreeningProceed = false;
      })
      .addCase(processProspectScreening.fulfilled, (state, action) => {
        state.loading = false;
        state.IsProspectScreeningProceed = true;
        state.redirect = "/";
        state.resultProcessProspectScreening = action.payload.data.status;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(processProspectScreening.rejected, (state, action) => {
        state.loading = false;
        state.IsProspectScreeningProceed = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  resetProspectScreeningStates,
  showNotification,
  hideNotification,
  showLoading,
} = ProspectScreeningSlice.actions;

export default ProspectScreeningSlice.reducer;
